export { checkGeolocPermission } from 'libs/location/geolocation/checkGeolocPermission/checkGeolocPermission'

export {
  GEOLOCATION_USER_ERROR_MESSAGE,
  GeolocPermissionState,
  GeolocPositionError,
} from './geolocation/enums'
export type { GeoCoordinates, GeolocationError, Position } from './types'
